<template>
  <div class="sp-tab-panel" :class="classModifiers">
    <slot />
  </div>
</template>

<script setup>
import { computed, shallowRef } from "vue";

import { useExpose } from "#ce/composables/useExpose";
import { booleanAttribute, toBoolean } from "#ce/utils/props";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  active: booleanAttribute(),
});

const groupActive = shallowRef(null);
const isActive = computed(() => groupActive.value ?? toBoolean(props.active));
const { exposeMethods } = useExpose();
exposeMethods({
  setActiveState(active) {
    groupActive.value = active;
  },
});

const classModifiers = computed(() => ({
  "--is-active": isActive.value,
}));
</script>

<style scoped lang="scss">
.sp-tab-panel {
  display: none;

  &.--is-active {
    display: block;
  }
}
</style>
